import dynamic from "next/dynamic";

const LazyLoad = dynamic(() => import("../../Image/LazyLoad"));

const FullBleedImageComponent = props => {
	const { block } = props;

	if (block.data.asset.kind === "image") {
		return (
			<div className="customContainer">
				<div className="row fullBleedImage">
					<div className="col s12">
						<div className="fullBleedImage">
							<LazyLoad image={block.data.asset} />
						</div>
					</div>
				</div>
			</div>
		);
	} else if (block.data.asset.kind === "json") {
		var video_id = block.data.asset.url.split("v=")[1];
		var ampersandPosition = video_id.indexOf("&");
		if (ampersandPosition != -1) {
			video_id = video_id.substring(0, ampersandPosition);
		}
		return (
			<div className="customContainer">
				<div className="row fullBleedImage">
					<div className="col s12">
						<div className="item-video video-container">
							<iframe
								className="youtubeVideo"
								width="1377"
								height="775"
								src={`https://www.youtube.com/embed/${video_id}?rel=0&showinfo=0&controls=0&modestbranding=0`}
								frameBorder="0"
								allowFullScreen="allowfullscreen"
							></iframe>
						</div>
					</div>
				</div>
			</div>
		);
	}
};

export default FullBleedImageComponent;
